// extracted by mini-css-extract-plugin
export default {"root":"offline-indicator_root__C9ynv","active":"offline-indicator_active__eiHiI","placeHolderShimmer":"offline-indicator_placeHolderShimmer__IeBii"};